function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const styles = require("./assets/style.json");

export const CircleMap = ({
  center,
  points,
  fitPoints,
  zoom = 6,
  ...props
}) => {
  const googleMapRef = React.createRef();
  const googleMap = useRef(null);

  const getPoints = points => {
    return points.map(point => ({
      location: new window.google.maps.LatLng(point.lat, point.lng)
    }));
  };

  const createGoogleMap = () => {
    var map = new window.google.maps.Map(googleMapRef.current, {
      zoom: zoom,
      mapTypeControl: false,
      streetViewControl: false,
      rotateControl: false,
      maxZoom: 7,
      minZoom: 2,
      center: center ? center : undefined,
      styles: styles
    });

    if (!!fitPoints) {
      var bounds = new window.google.maps.LatLngBounds();
      getPoints(fitPoints).map(point => bounds.extend(point.location));
      map.fitBounds(bounds);
    }

    return map;
  };

  const createMarker = points => {
    return points.map(point => new window.google.maps.Circle({
      center: {
        lat: Number(point.lat),
        lng: Number(point.lng)
      },
      map: googleMap.current,
      radius: Math.sqrt(point.size) * 20000,
      strokeWeight: 0,
      fillColor: "#6DCC6A",
      fillOpacity: 0.48
    }));
  };

  useEffect(() => {
    googleMap.current = createGoogleMap();
    createMarker(points);
  }, [points]);
  return React.createElement(MapContainer, _extends({
    id: "google-map",
    ref: googleMapRef
  }, props));
};
const MapContainer = styled.div`
  border: 1px solid #596266;
  box-sizing: border-box;
  display: block;
  height: 442px;
  width: 100%;
`;